// extracted by mini-css-extract-plugin
export default {"view":"Crystals_view__aVY2K","title":"Crystals_title__f+Xdo","content":"Crystals_content__K0+Xz"};